export const SET_SLEEP_DATA = 'SET_SLEEP_DATA'
export const SET_HEARTBEAT_DATA = 'SET_HEARTBEAT_DATA'
export const SET_SUMMARY_DATA = 'SET_SUMMARY_DATA'
export const SET_USER_INFO = 'SET_USER_INFO'
